import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserProgress } from '../../views/Activity/store/ActivitySelectors'
import { YumUserActivity, IYumUserActivityProps } from './YumUserActivity'
import { GoalWithProgress, ServiceProvider } from '../../services/api.types'

export interface IOwnProps {
  goalDto: GoalWithProgress
  serviceProvider: ServiceProvider
  isUser: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IYumUserActivityProps => {
  const { goalDto, serviceProvider, isUser } = ownProps
  const goalId = goalDto.id
  return {
    goalDto,
    userProgress: getUserProgress(state, goalId),
    serviceProvider,
    isUser,
  }
}

export default connect(mapStateToProps)(YumUserActivity)
